var _a;
// get the src of the current script (no point in removing the script we are already executing)
const currentScriptSrc = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.getAttribute("src");
export { currentScriptSrc };
